import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';
import {Form} from 'formik';
import FieldSignature from '../../components/FieldSignature';
import Button from '../../components/Button';
import ErrorValidation from '../../components/ErrorValidation';
import styles from './styles.module.scss';

const Step9View = ({isValid}) => {
  return (
    <Form className={styles.formContainer}>
      <div className={`${styles.innerPadding} ${styles.input}`}>
        <div className={styles.titleBold}>
          <FormattedMessage
            id="step9.form.title"
          />
        </div>
      </div>
      <div className={styles.innerPadding}>
        <div className={styles.input}>
          <FormattedMessage
            id={'step9.form.note.declaration'}
            defaultMessage={'I hereby declare that all the details I have provided are correct and complete. I am aware that providing incorrect information or omitting data is a violation of the law, and that a person who fraudulently or knowingly causes an annuity under this law or increases it, by omitting details that are relevant to the matter, is liable to a fine or imprisonment. I know that if there are changes in the contact details, I must notify the National Insurance Institute. In case the contact details are not updated, the information will be sent through the channels I indicated on this form.'}
          />
        </div>
        <div className={styles.input}>
          <FormattedMessage
            id={'step9.form.note.declaration.2'}
          />
        </div>
        <div className={`${styles.input} ${styles.text} ${styles.lightColor} ${styles.bigMargin}`}>
          <FormattedMessage
            id={'common.form.note.unigender'}
            defaultMessage={'The form is worded in masculine language but is addressed to both men and women'}
          />
        </div>
        <FieldSignature
          fieldId='signature'
          label={(
            <FormattedMessage
              id='common.form.signature.label'
              defaultMessage={'Customer\'s signature'}
            />
          )}
          containerStyles={styles.input}
          disabled={true}
        />
        <Button
          type='submit'
          label={(
            <FormattedMessage
              id='common.form.button.save'
              defaultMessage='Save'
            />
          )}
        />
        {!isValid && <ErrorValidation />}
      </div>
    </Form>
  )
};

Step9View.propTypes = {
  isValid: PropTypes.bool,
};

export default Step9View;
